import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import html2pdf from "html2pdf.js";
import Logo from "../../assets/logo.png";
import axios from "axios";
import { apiUrl } from "../../constants";

const InvoiceForCust = ({ invoiceData }) => {
  const invoiceRef = useRef(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState(null);

  const totalAmount = invoiceData.total_amount;
  const totalCGST = invoiceData.cgst;
  const totalSGST = invoiceData.sgst;
  const discount = invoiceData.discount || 0;
  const totalTax = totalCGST + totalSGST;
  console.log(invoiceData.details, "asdfghjkl;");

  const grandTotal = totalAmount + totalTax - discount;

  // Function to calculate package details and amounts
  const calculatePackageDetails = (details, totalAmount) => {
    let regularPackages = [];
    let unlimitedPackages = [];
    let totalUnlimitedAmount = 0;
    let totalRegularAmount = 0;

    // Process each person's details
    if (details && Array.isArray(details)) {
      details.forEach((person, personIndex) => {
        if (person.package && Array.isArray(person.package)) {
          person.package.forEach((pkg, pkgIndex) => {
            if (pkg.packageType === "regular" && pkg.package) {
              regularPackages.push({
                personName: person.person_name,
                packageId: pkg.package,
                type: "regular",
              });
            } else if (
              pkg.packageType === "unlimited" &&
              pkg.unlimitedPackageData
            ) {
              const unlimitedData = pkg.unlimitedPackageData;
              totalUnlimitedAmount += unlimitedData.price || 0;
              unlimitedPackages.push({
                personName: person.person_name,
                name: unlimitedData.name,
                price: unlimitedData.price,
                activities: unlimitedData.activities,
                type: "unlimited",
              });
            }
          });
        }
      });
    }

    // Calculate regular package amount
    totalRegularAmount = totalAmount - totalUnlimitedAmount;

    return {
      regularPackages,
      unlimitedPackages,
      totalRegularAmount,
      totalUnlimitedAmount,
      hasRegular: regularPackages.length > 0,
      hasUnlimited: unlimitedPackages.length > 0,
    };
  };

  //  Get package details
  const packageDetails = calculatePackageDetails(
    invoiceData.details || [],
    totalAmount,
  );

  // Function to get package description for invoice
  const getPackageDescription = () => {
    const {
      hasRegular,
      hasUnlimited,
      regularPackages,
      unlimitedPackages,
      totalRegularAmount,
      totalUnlimitedAmount,
    } = packageDetails;

    if (hasRegular && hasUnlimited) {
      return {
        description: `Mixed Package (${invoiceData.count} ${
          invoiceData.count > 1 ? "persons" : "person"
        }) - Regular: ₹${totalRegularAmount.toFixed(
          2,
        )}, Unlimited: ₹${totalUnlimitedAmount.toFixed(2)}`,
        breakdown: `Regular Packages: ₹${totalRegularAmount.toFixed(
          2,
        )}\nUnlimited Packages: ₹${totalUnlimitedAmount.toFixed(2)}`,
      };
    } else if (hasRegular && !hasUnlimited) {
      return {
        description: `Regular Package (${invoiceData.count} ${
          invoiceData.count > 1 ? "persons" : "person"
        })`,
        breakdown: `Regular Package Amount: ₹${totalRegularAmount.toFixed(2)}`,
      };
    } else if (!hasRegular && hasUnlimited) {
      const unlimitedDetails = unlimitedPackages
        .map((pkg) => `${pkg.name}: ₹${pkg.price.toFixed(2)}`)
        .join("\n");
      return {
        description: `Unlimited Package (${invoiceData.count} ${
          invoiceData.count > 1 ? "persons" : "person"
        })`,
        breakdown: unlimitedDetails,
      };
    } else {
      return {
        description: `Package (${invoiceData.count} ${
          invoiceData.count > 1 ? "persons" : "person"
        })`,
        breakdown: `Package Amount: ₹${totalAmount.toFixed(2)}`,
      };
    }
  };

  const getCurrentSno = async () => {
    try {
      const invoiceSnoData = await axios.get(`${apiUrl}/bill/billsno`);
      let currentInvoiceNumber = invoiceSnoData.data.message;
      setInvoiceNumber(currentInvoiceNumber);
    } catch (error) {
      setErrorMessage("Error fetching invoice number: " + error.message);
    }
  };

  const currentDate = new Date().toLocaleDateString("en-US");
  const gstNumber = "23AAJFF2527Q1Z5";
  const hsnCode = "999699";

  const downloadPDF = async (pdfBlob) => {
    try {
      setIsProcessing(false);

      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice_${invoiceNumber}.pdf`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      console.log("PDF downloaded successfully");
    } catch (error) {
      setErrorMessage("Error downloading invoice: " + error.message);
    }
  };

  const postBillPayment = async () => {
    try {
      const salesId = await axios.get(`${apiUrl}/insights/salesId`);
      let Id = salesId.data.nextId;
      const [month, day, year] = currentDate.split("/");
      const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
        2,
        "0",
      )}`;

      const responseSales = await axios.post(`${apiUrl}/insights/salesadd`, {
        _id: Id,
        date: formattedDate,
        amount: grandTotal,
        section: "Ticket Counter",
        split: "Activities",
      });

      const response = await axios.post(`${apiUrl}/bill/billpayment`, {
        sno: invoiceNumber,
        Date: currentDate,
        CashAmount: invoiceData.cash_amount || 0,
        OnlineAmount: invoiceData.online_amount || grandTotal,
        paymentType: invoiceData.payment_mode,
        amount: totalAmount,
        discount: discount,
        discountType: discount > 0 ? "DISCOUNT" : "",
        cgst: totalCGST,
        sgst: totalSGST,
        total: grandTotal,
        phone_no: invoiceData.phone_no,
        name: invoiceData.name,
      });

      if (response.data.success) {
        console.log("Data is added");
      } else {
        console.error("Failed to add data");
      }
    } catch (error) {
      console.error("Error posting bill payment:", error);
    }
  };

  const generateAndDownloadPDF = async () => {
    try {
      setIsProcessing(true);
      setErrorMessage("");

      setShowInvoice(true);

      await new Promise((resolve) => setTimeout(resolve, 500));

      const invoiceContent = invoiceRef.current;

      if (!invoiceContent) {
        console.error("Invoice content not available");
        setErrorMessage("Invoice content not available");
        return;
      }

      const options = {
        margin: 10,
        filename: `Invoice_${invoiceNumber}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      const pdfBlob = await html2pdf()
        .set(options)
        .from(invoiceContent)
        .output("blob");

      console.log("PDF generated successfully, size:", pdfBlob.size, "bytes");

      setShowInvoice(false);

      await downloadPDF(pdfBlob);
    } catch (error) {
      console.error("Error in PDF generation or download:", error);
      setErrorMessage("Error processing invoice: " + error.message);
      setShowInvoice(false);
    }
  };

  useEffect(() => {
    if (invoiceData) {
      getCurrentSno();
    }
  }, [invoiceData]);

  useEffect(() => {
    if (invoiceData && invoiceNumber !== null) {
      const timer = setTimeout(() => {
        generateAndDownloadPDF();
        postBillPayment();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [invoiceData, invoiceNumber]);

  // NEW: Get package info for display
  const packageInfo = getPackageDescription();

  return (
    <div>
      {isProcessing && <div className="upload-status">Generating PDF...</div>}
      {errorMessage && (
        <div className="upload-status error">{errorMessage}</div>
      )}

      {/* Only show invoice when invoice number is available */}
      {showInvoice && invoiceNumber !== null && (
        <div ref={invoiceRef}>
          <div id="invoice-main">
            <div id="upperDiv">
              <h3>S.NO.: {invoiceNumber}</h3>
              <h3>TAX INVOICE</h3>
              <img src={Logo} alt="Company Logo" />
            </div>

            <div id="lowerDiv">
              <h3>Date: {currentDate}</h3>
              <h3>GST No.: {gstNumber}</h3>
              <h3>HSN CODE.: {hsnCode}</h3>
            </div>

            {/* Customer Information */}
            <div
              id="customerInfo"
              style={{
                margin: "10px 0",
                padding: "10px",
                border: "1px solid #ccc",
              }}
            >
              <p>
                <strong>Name:</strong> {invoiceData.name}
              </p>
              <p>
                <strong>Phone:</strong> {invoiceData.phone_no}
              </p>
              {invoiceData.dob && (
                <p>
                  <strong>DOB:</strong> {invoiceData.dob}
                </p>
              )}
              <p>
                <strong>Total Persons:</strong> {invoiceData.count}
              </p>
            </div>

            <div id="mode">
              <h5>PAYMENT MODE: {invoiceData.payment_mode.toUpperCase()}</h5>
            </div>

            <div id="table">
              <table>
                <thead>
                  <tr id="head">
                    <th
                      className="invoicehead"
                      style={{ borderRight: "3px solid black" }}
                    >
                      S.No
                    </th>
                    <th
                      className="invoicehead"
                      style={{ borderRight: "3px solid black" }}
                    >
                      Package
                    </th>
                    <th
                      className="invoicehead"
                      style={{ borderRight: "3px solid black" }}
                    >
                      Amount
                    </th>
                    <th className="invoicehead">Net Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Regular (Coin-based) Package Row - only show if exists */}
                  {packageDetails.hasRegular && (
                    <tr id="datail">
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        1
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          borderRight: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        Coin Based Package
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderBottom: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        ₹{packageDetails.totalRegularAmount.toFixed(2)}
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          borderRight: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        ₹{packageDetails.totalRegularAmount.toFixed(2)}
                      </td>
                    </tr>
                  )}

                  {/* Unlimited Package Row - only show if exists */}
                  {packageDetails.hasUnlimited && (
                    <tr id="datail">
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        {packageDetails.hasRegular ? 2 : 1}
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          borderRight: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        Unlimited Package
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderBottom: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        ₹{packageDetails.totalUnlimitedAmount.toFixed(2)}
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          borderRight: "3px solid black",
                          marginBottom: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        ₹{packageDetails.totalUnlimitedAmount.toFixed(2)}
                      </td>
                    </tr>
                  )}

                  {/* Tax calculation row */}
                  <tr id="datail">
                    <td
                      className="invoicedatatable"
                      style={{
                        borderLeft: "3px solid black",
                        borderBottom: "3px solid black",
                        paddingBottom: "10px",
                      }}
                    >
                      {(() => {
                        let rowNumber = 1;
                        if (packageDetails.hasRegular) rowNumber++;
                        if (packageDetails.hasUnlimited) rowNumber++;
                        return rowNumber;
                      })()}
                    </td>
                    <td
                      className="invoicedatatable"
                      style={{
                        borderLeft: "3px solid black",
                        borderBottom: "3px solid black",
                        borderRight: "3px solid black",
                        paddingBottom: "10px",
                      }}
                    >
                      Tax Calculation
                    </td>
                    <td
                      className="invoicedatatable"
                      style={{
                        borderBottom: "3px solid black",
                        paddingBottom: "10px",
                      }}
                    >
                      <ul>
                        <li
                          className="listInvoiceAmount"
                          style={{ borderBottom: "2px solid black" }}
                        >
                          Subtotal: ₹{totalAmount.toFixed(2)}
                        </li>
                        <li
                          className="listInvoiceAmount"
                          style={{ borderBottom: "2px solid black" }}
                        >
                          CGST 9%: ₹{totalCGST.toFixed(2)}
                        </li>
                        <li
                          className="listInvoiceAmount"
                          style={{ borderBottom: "2px solid black" }}
                        >
                          SGST 9%: ₹{totalSGST.toFixed(2)}
                        </li>
                        <li style={{ padding: "10px" }}>
                          Total Tax: ₹{totalTax.toFixed(2)}
                        </li>
                      </ul>
                    </td>
                    <td
                      className="invoicedatatable"
                      style={{
                        borderLeft: "3px solid black",
                        borderBottom: "3px solid black",
                        borderRight: "3px solid black",
                        paddingBottom: "10px",
                      }}
                    >
                      ₹{totalTax.toFixed(2)}
                    </td>
                  </tr>

                  {/* Discount row - only show if discount exists */}
                  {discount > 0 && (
                    <tr id="datail">
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          paddingBottom: "10px",
                        }}
                      >
                        {(() => {
                          let rowNumber = 2;
                          if (packageDetails.hasRegular) rowNumber++;
                          if (packageDetails.hasUnlimited) rowNumber++;
                          return rowNumber;
                        })()}
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          borderRight: "3px solid black",
                          paddingBottom: "10px",
                        }}
                      >
                        Discount
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderBottom: "3px solid black",
                          paddingBottom: "10px",
                          color: "red",
                        }}
                      >
                        -₹{discount.toFixed(2)}
                      </td>
                      <td
                        className="invoicedatatable"
                        style={{
                          borderLeft: "3px solid black",
                          borderBottom: "3px solid black",
                          borderRight: "3px solid black",
                          paddingBottom: "10px",
                          color: "red",
                        }}
                      >
                        -₹{discount.toFixed(2)}
                      </td>
                    </tr>
                  )}

                  {/* Total Payment row */}
                  <tr id="datail">
                    <td
                      className="invoicedatatable"
                      style={{
                        borderLeft: "3px solid black",
                        borderBottom: "3px solid black",
                        paddingBottom: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      {(() => {
                        let rowNumber = 2;
                        if (packageDetails.hasRegular) rowNumber++;
                        if (packageDetails.hasUnlimited) rowNumber++;
                        if (discount > 0) rowNumber++;
                        return rowNumber;
                      })()}
                    </td>
                    <td
                      className="invoicedatatable"
                      style={{
                        borderLeft: "3px solid black",
                        borderBottom: "3px solid black",
                        borderRight: "3px solid black",
                        paddingBottom: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      TOTAL PAYMENT
                    </td>
                    <td
                      className="invoicedatatable"
                      style={{
                        borderBottom: "3px solid black",
                        paddingBottom: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      ₹{grandTotal.toFixed(2)}
                    </td>
                    <td
                      className="invoicedatatable"
                      style={{
                        borderLeft: "3px solid black",
                        borderBottom: "3px solid black",
                        borderRight: "3px solid black",
                        paddingBottom: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      ₹{grandTotal.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div
                id="accountDetails"
                style={{
                  border: "3px solid black",
                  marginTop: "1rem",
                  height: "8rem",
                  padding: "20px",
                }}
              >
                <h3 style={{ marginBottom: "8px" }}>Bank Name: YES BANK</h3>
                <h3 style={{ marginBottom: "8px" }}>
                  A/C No.: 044463700000949
                </h3>
                <h3 style={{ marginBottom: "8px" }}>IFSC CODE: YESB0000444</h3>
              </div>

              <h4 style={{ marginTop: "14px" }}>
                This is a system-generated invoice and does not require
                signature or Stamp.
              </h4>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoiceForCust;
